"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ContextProvider = exports.Context = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = _interopRequireWildcard(require("react"));

var _config = require("./config");

var _reducer = require("./reducer");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var Context = /*#__PURE__*/(0, _react.createContext)({
  state: _reducer.initialState,
  config: (0, _config.getDefaultConfig)(),
  dispatch: function dispatch() {
    return null;
  }
});
exports.Context = Context;

var ContextProvider = function ContextProvider(props) {
  var children = props.children;
  var _props$config = props.config,
      userToken = _props$config.userToken,
      guid = _props$config.guid,
      enableNoneAreMyIncome = _props$config.enableNoneAreMyIncome,
      enableTotalIncomeNotShown = _props$config.enableTotalIncomeNotShown;

  var _useReducer = (0, _react.useReducer)(_reducer.reducer, _objectSpread(_objectSpread({}, _reducer.initialState), {}, {
    userToken: userToken,
    guid: guid,
    enableNoneAreMyIncome: enableNoneAreMyIncome !== null && enableNoneAreMyIncome !== void 0 ? enableNoneAreMyIncome : true,
    enableTotalIncomeNotShown: enableTotalIncomeNotShown !== null && enableTotalIncomeNotShown !== void 0 ? enableTotalIncomeNotShown : false
  })),
      _useReducer2 = (0, _slicedToArray2.default)(_useReducer, 2),
      state = _useReducer2[0],
      dispatch = _useReducer2[1];

  var config = (0, _react.useMemo)(function () {
    return (0, _config.getConfig)(props.config);
  }, [props.config]);
  return /*#__PURE__*/_react.default.createElement(Context.Provider, {
    children: children,
    value: {
      state: state,
      config: config,
      dispatch: dispatch
    }
  });
};

exports.ContextProvider = ContextProvider;